'use client'

import { MutableRefObject, useEffect, useRef, useState } from 'react'

export function useScrollBottom(feedData: any) {
  const [isBottom, setIsBottom] = useState(false)

  function handleScroll() {
    const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
    const scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) || document.body.scrollHeight
    if (scrollTop + window.innerHeight + 50 >= scrollHeight) {
      setIsBottom(true)
    } else {
      setIsBottom(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  // New useEffect
  useEffect(() => {
    if (isBottom) {
      setIsBottom(false)
    }
  }, [feedData])

  return isBottom
}

const useIntersectionObserver = (
  callback: () => void,
  options: IntersectionObserverInit = {},
): MutableRefObject<HTMLDivElement | null> => {
  const observerRef = useRef<IntersectionObserver | null>(null)
  const targetRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (observerRef.current) observerRef.current.disconnect()

    observerRef.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        callback()
      }
    }, options)

    if (targetRef.current) {
      observerRef.current.observe(targetRef.current)
    }

    return () => {
      if (observerRef.current) observerRef.current.disconnect()
    }
  }, [callback, options])

  return targetRef
}

export default useIntersectionObserver
